import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  gap: 6px;
`;

export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  width: 45px;
  min-width: 45px;
  height: 45px;
  min-height: 45px;

  border-radius: 4px;
  border: 0.5px solid ${({ theme }) => theme.colors.WhiteGray};

  &.yellow {
    border: 0.5px solid ${({ theme }) => theme.colors.DarkYellow};
  }

  & img {
    width: 45px;
    height: 45px;
    object-fit: contain;
  }
`;
